export const isRogaine = (eventType: string | null | undefined): boolean =>
  eventType?.startsWith('rogaine') ?? false;
